import { defineStore } from 'pinia';
import { getPackagingMasters } from '@/services/modules/packaging-master';

export interface PackagingMaster {
  id: number;
  style: string;
  code?: number;
}

export const usePackagingMasterStore = defineStore({
  id: 'packagingMaster',
  state: (): { packagingMasters: PackagingMaster[] } => ({
    packagingMasters: []
  }),
  getters: {},
  actions: {
    async getPackagingMasters() {
      const response = await getPackagingMasters();
      this.packagingMasters = response as PackagingMaster[];
    }
  }
});
